var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 51.3333V35",
    stroke: "url(#paint0_linear_21_142693)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 35C9.33331 35 11.6666 32.6666 18.6666 32.6666C25.6666 32.6666 30.3333 37.3333 37.3333 37.3333C44.3333 37.3333 46.6666 35 46.6666 35V6.99996C46.6666 6.99996 44.3333 9.33329 37.3333 9.33329C30.3333 9.33329 25.6666 4.66663 18.6666 4.66663C11.6666 4.66663 9.33331 6.99996 9.33331 6.99996V35Z",
    fill: "url(#paint1_linear_21_142693)",
    stroke: "url(#paint2_linear_21_142693)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_142693",
    x1: 9.4492,
    y1: 35,
    x2: 11.3682,
    y2: 35.1573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_142693",
    x1: 13.6598,
    y1: 4.66663,
    x2: 35.2382,
    y2: 37.6924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_142693",
    x1: 13.6598,
    y1: 4.66663,
    x2: 35.2382,
    y2: 37.6924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDReport);
export default __webpack_public_path__ + "static/media/d_report.5b04a996230a69912a6660e3de6151af.svg";
export { ForwardRef as ReactComponent };